import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, PlayerName, LoadingSpinner } from 'yankees-react-utils';
import { useOktaQuery, PitchTipping } from '../../../../data';
import ReportCard from '../../../../components/ReportCard';
import TippingPlayer from '../../../../components/TippingPlayer';

const TippingReportPlayer = ({ playerId, player, hasOneOrMoreTipsCallback }) => {
    const [open, setOpen] = useState(false);

    const { data, isFetching: loading } = useOktaQuery(['tipping', { playerId }], (t) => PitchTipping.getNotes(t, playerId), {
        onSuccess: (result) => {
            if (result.length > 0 && hasOneOrMoreTipsCallback) {
                hasOneOrMoreTipsCallback(result.length);
            }
        },
    });

    if (loading) return <LoadingSpinner />;

    return (
        <>
            {data?.length > 0 && (
                <>
                    <ReportCard>
                        <h4>
                            <PlayerName player={player} />
                            <span className="small" style={{ float: 'right', cursor: 'pointer' }} onClick={() => setOpen(!open)}>
                                {open ? <Icon icon="chevron-up" /> : <Icon icon="chevron-down" />}
                            </span>
                        </h4>
                        {open && (
                            <>
                                <TippingPlayer data={data} playerId={playerId} showNoneIfNoTippingNotes={false} />
                            </>
                        )}
                    </ReportCard>
                </>
            )}
            {(!data || data?.length === 0) && <></>}
        </>
    );
};

TippingReportPlayer.propTypes = {
    playerId: PropTypes.number.isRequired,
    player: PropTypes.shape({
        PlayerID: PropTypes.number,
        FirstName: PropTypes.string,
        LastName: PropTypes.string,
    }),
    hasOneOrMoreTipsCallback: PropTypes.func,
};
TippingReportPlayer.defaultProps = {
    player: {},
    hasOneOrMoreTipsCallback: undefined,
};

export default TippingReportPlayer;
